import styled from "styled-components";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import { MOBILE_BREAKPOINT } from "@ryde/theme";
import { landingColors } from "@ryde/utils-landings";

export const ClalWrapper = styled.div`
  width: 100%;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${RASTER_LANDINGS.ClalBgJPG}) no-repeat;
  background-size: 100% auto;
  overflow: auto;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    background: white;
  }

  .landing-outside-container {
    width: 100%;
    max-height: 100%;
    margin: 0px;
    height: 100vh;
    padding: 100px 0px;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      width: 100%;
      padding: 0px;
    }
  }

  .landing-container {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    padding: 20px 70px;
    max-width: 500px;
    width: 100%;
    position: relative;
    align-items: center;

    form {
      display: flex;
      flex-direction: column;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      width: 100%;
      padding: 40px;
      box-shadow: none;
      border: none;
      gap: 8px;
      min-height: 100%;
    }
  }

  .landing-logo {
    display: flex;
    justify-content: center;
    cursor: pointer;
    border: none;
    background: transparent;
    padding: 0;

    &:focus-visible {
      outline: 2px solid ${landingColors.royalPurple};
      outline-offset: 2px;
    }

    .landing-logo__img {
      object-fit: contain;
    }
  }

  .landing-title {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: ${landingColors.royalPurple};
    margin-bottom: 30px;
    line-height: 1.4;
  }
  .landing-title_choose-station {
    margin-bottom: 5px;
  }
  .landing-sub-title {
    text-align: center;
    color: ${landingColors.royalPurple};
    margin-bottom: 20px;
  }
  .v-green-icon {
    margin: auto;
  }

  .downloads-app-container {
    display: flex;
    align-items: stretch;
    max-height: 40px;
    justify-content: space-evenly;
    gap: 5px;

    img {
      width: 120px;
      object-fit: contain;
    }
  }

  .landing-form-field {
    margin-bottom: 20px;
    width: 370px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      width: initial;
    }

    label,
    .custom-label {
      display: block;
      margin-bottom: 8px;
      font-weight: 500;
      color: ${landingColors.darkGray};
      font-size: 14px;
    }

    &.hidden {
      visibility: hidden;
      margin-bottom: 0px;
      height: 0;
    }
  }

  .MuiFormControl-root {
    width: 100%;

    .Mui-error {
      text-align: start;
    }
  }

  .landing-form-field__email {
    svg {
      display: none;
    }
  }

  .landing-accept-terms {
    display: flex;
    column-gap: 10px;
  }

  .landing-top-illustration {
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
  }

  .landing-help-disclaimer {
    color: ${landingColors.red};
  }

  .continue-button {
    align-self: center;
  }

  .purple-link {
    margin-top: 10px;
    color: ${landingColors.textPurple};
    align-self: center;
    border: none;
    background: transparent;
    padding: 0;
    font: inherit;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${landingColors.textPurple};
      outline-offset: 2px;
    }
  }

  .landing-container-footer {
    margin-top: 30px;
    text-align: center;
  }

  .landing-bottom-illustration {
    height: 60px;
    background: linear-gradient(45deg, #667eea, #764ba2);
    border-radius: 8px;
    margin: 20px 0;
    opacity: 0.1;
  }

  .landing-customer-support {
    margin-top: 20px;
    color: ${landingColors.darkGray};
    display: inline-block;
    line-height: 1.7em;
  }
`;
